<template>
  <layout>
    <div slot="content">
      <div class="page-title">客服沟通统计</div>

      <!-- 筛选区 -->
      <div class="search-bar">
        <el-form inline size="small">
          <el-form-item label="管理员">
            <el-select v-model="filter.admin_user_id" placeholder="全部" clearable style="width:150px">
              <el-option
                v-for="item in adminOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="statLoading" @click="loadStat">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 汇总统计卡片 -->
      <div v-if="isSuperAdmin" v-loading="statLoading" class="stat-cards-wrap">
        <div v-if="!statLoading && statList.length === 0" class="empty-block">
          <i class="el-icon-s-data empty-icon"></i>
          <p class="empty-text">暂无沟通数据，请调整筛选条件后重新查询</p>
        </div>
        <div class="stat-cards">
          <div
            v-for="item in statList"
            :key="item.admin_user_id"
            class="stat-card"
            :class="{ 'stat-card--active': selectedAdmin === item.admin_user_id }"
            @click="selectAdmin(item.admin_user_id)">
            <div class="stat-name">{{ item.admin_real_name }}</div>
            <div class="stat-total">{{ item.total }}</div>
            <div class="stat-sub">
              <span>PC: {{ item.pc_total }}</span>
              <span style="margin-left:10px">移动: {{ item.mobile_total }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 明细列表 -->
      <div v-if="selectedAdmin !== null" class="detail-section">
        <div class="detail-title">
          {{ selectedAdminName }} 沟通明细
          <el-button size="mini" style="margin-left:12px" @click="clearSelected">返回汇总</el-button>
        </div>
        <el-table :data="detailList" border stripe size="small" v-loading="detailLoading">
          <template slot="empty">
            <div class="table-empty">
              <i class="el-icon-document table-empty-icon"></i>
              <p>暂无明细记录</p>
            </div>
          </template>
          <el-table-column label="订单号" prop="order_uuid" width="220"></el-table-column>
          <el-table-column label="简码" prop="short_code" width="100"></el-table-column>
          <el-table-column label="产品名称" prop="order_title" show-overflow-tooltip></el-table-column>
          <el-table-column label="出行人数" prop="order_goods_count" width="80" align="center"></el-table-column>
          <el-table-column label="联系电话" prop="linker_mobile" width="120"></el-table-column>
          <el-table-column label="来源" prop="source_name" width="80" align="center"></el-table-column>
          <el-table-column label="沟通时间" prop="created_at" width="160"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="detailTotal"
            :page-size="pageSize"
            :current-page="detailPage"
            @current-change="onDetailPageChange">
          </el-pagination>
        </div>
      </div>

      <!-- 本人明细（非超管）-->
      <div v-if="!isSuperAdmin" class="detail-section">
        <div class="detail-title">我的沟通明细</div>
        <div class="search-bar" style="margin-top:0">
          <el-form inline size="small">
            <el-form-item label="日期范围">
              <el-date-picker
                v-model="myDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width:240px">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="myLoading" @click="loadMyList">查询</el-button>
              <el-button @click="resetMyFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="myList" border stripe size="small" v-loading="myLoading">
          <template slot="empty">
            <div class="table-empty">
              <i class="el-icon-document table-empty-icon"></i>
              <p>暂无沟通记录，请调整日期范围后重新查询</p>
            </div>
          </template>
          <el-table-column label="订单号" prop="order_uuid" width="220"></el-table-column>
          <el-table-column label="简码" prop="short_code" width="100"></el-table-column>
          <el-table-column label="产品名称" prop="order_title" show-overflow-tooltip></el-table-column>
          <el-table-column label="出行人数" prop="order_goods_count" width="80" align="center"></el-table-column>
          <el-table-column label="联系电话" prop="linker_mobile" width="120"></el-table-column>
          <el-table-column label="来源" prop="source_name" width="80" align="center"></el-table-column>
          <el-table-column label="沟通时间" prop="created_at" width="160"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="myTotal"
            :page-size="pageSize"
            :current-page="myPage"
            @current-change="onMyPageChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'

export default {
  name: 'communicate-stat',
  components: { layout },
  data() {
    return {
      isSuperAdmin: false,
      adminOptions: [],
      filter: {
        admin_user_id: ''
      },
      dateRange: [],
      statLoading: false,
      statList: [],
      selectedAdmin: null,
      selectedAdminName: '',
      detailList: [],
      detailTotal: 0,
      detailPage: 1,
      detailLoading: false,
      // 本人明细
      myDateRange: [],
      myList: [],
      myTotal: 0,
      myPage: 1,
      myLoading: false,
      pageSize: 20
    }
  },
  created() {
    this.$http.request('isSuperAdmin').then(res => {
      this.isSuperAdmin = res.data && res.data.is_super_admin
      if (this.isSuperAdmin) {
        this.loadAdminOptions()
        this.loadStat()
      } else {
        this.loadMyList()
      }
    })
  },
  methods: {
    loadAdminOptions() {
      this.$http.request('adminOptionsForCommunicate').then(res => {
        if (res.status === 'success') {
          this.adminOptions = res.data || []
        }
      })
    },
    loadStat() {
      this.statLoading = true
      const params = {}
      if (this.filter.admin_user_id) params.admin_user_id = this.filter.admin_user_id
      if (this.dateRange && this.dateRange.length === 2) {
        params.start_date = this.dateRange[0]
        params.end_date   = this.dateRange[1]
      }
      this.$http.request('communicateDashboard', params).then(res => {
        this.statLoading = false
        if (res) {
          this.statList = res.data || []
        }
      }).catch(() => { this.statLoading = false })
    },
    selectAdmin(adminUserId) {
      this.selectedAdmin = adminUserId
      const found = this.statList.find(item => item.admin_user_id === adminUserId)
      this.selectedAdminName = found ? found.admin_real_name : ''
      this.detailPage = 1
      this.loadDetail()
    },
    clearSelected() {
      this.selectedAdmin = null
      this.detailList = []
      this.detailTotal = 0
    },
    loadDetail() {
      this.detailLoading = true
      const params = { admin_user_id: this.selectedAdmin, page: this.detailPage }
      if (this.dateRange && this.dateRange.length === 2) {
        params.start_date = this.dateRange[0]
        params.end_date   = this.dateRange[1]
      }
      this.$http.request('communicateDashboardDetail', params).then(res => {
        this.detailLoading = false
        if (res) {
          this.detailList  = res.data || []
          this.detailTotal = res.meta ? res.meta.total : 0
        }
      }).catch(() => { this.detailLoading = false })
    },
    onDetailPageChange(page) {
      this.detailPage = page
      this.loadDetail()
    },
    loadMyList() {
      this.myLoading = true
      const params = { page: this.myPage }
      if (this.myDateRange && this.myDateRange.length === 2) {
        params.start_date = this.myDateRange[0]
        params.end_date   = this.myDateRange[1]
      }
      this.$http.request('myCommunicateList', params).then(res => {
        this.myLoading = false
        if (res) {
          this.myList  = res.data || []
          this.myTotal = res.meta ? res.meta.total : 0
        }
      }).catch(() => { this.myLoading = false })
    },
    onMyPageChange(page) {
      this.myPage = page
      this.loadMyList()
    },
    resetFilter() {
      this.filter = { admin_user_id: '' }
      this.dateRange = []
      this.clearSelected()
      this.loadStat()
    },
    resetMyFilter() {
      this.myDateRange = []
      this.myPage = 1
      this.loadMyList()
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}
.search-bar {
  background: #fff;
  padding: 12px 16px 0;
  border-radius: 4px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
}
.stat-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}
.stat-card {
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  padding: 14px 20px;
  min-width: 140px;
  cursor: pointer;
  transition: border-color .2s;
  text-align: center;
}
.stat-card:hover,
.stat-card--active {
  border-color: #409eff;
}
.stat-name {
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
}
.stat-total {
  font-size: 28px;
  font-weight: bold;
  color: #409eff;
  line-height: 1;
}
.stat-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
}
.detail-section {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
  margin-bottom: 16px;
}
.detail-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 12px;
}
.pagination-wrap {
  margin-top: 12px;
  text-align: right;
}
.stat-cards-wrap {
  min-height: 80px;
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #909399;
}
.empty-icon {
  font-size: 48px;
  color: #dcdfe6;
  margin-bottom: 10px;
}
.empty-text {
  font-size: 13px;
  margin: 0;
}
.table-empty {
  padding: 24px 0;
  color: #909399;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.table-empty-icon {
  font-size: 36px;
  color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/communicate-stat.vue